import { addProp } from "@pnp/odata";
import { _Item } from "../items/types.js";
import { File } from "./types.js";
addProp(_Item, "file", File, "file");
//# sourceMappingURL=item.js.map